/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfListOfAudit } from '../../models/data-page-of-list-of-audit';

export interface AuditGetAll$Params {
  Page?: number;
}

export function auditGetAll(http: HttpClient, rootUrl: string, params?: AuditGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfListOfAudit>> {
  const rb = new RequestBuilder(rootUrl, auditGetAll.PATH, 'get');
  if (params) {
    rb.query('Page', params.Page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfListOfAudit>;
    })
  );
}

auditGetAll.PATH = '/api/Audit';
